import { Component, OnInit, OnDestroy, Input, ViewEncapsulation, HostListener} from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { AppDetailsService } from '../services/app-details.services';
import { BannerService } from '../services/banner.service';
import { Utility } from '../shared/utility/utility';
import { EmitterService } from '../services/emitter.service';
import * as $ from 'jquery';
window['$'] = window['jQuery'] = $;
import { CountryDataService } from '../services/country.service';
import { UserDetailsService } from '../services/user-details.service';
import { Subject } from 'rxjs';
import { ProfileSettingService } from '../services/profile-setting.service';
import { TitleCasePipe } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import { pnpLanguagePaymentlogos } from '../shared/utility/config';
@Component({
  selector: 'app-homebanner',
  templateUrl: './app-homebanner.component.html',
  styleUrls: ['./app-homebanner.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppHomebannerComponent implements OnInit, OnDestroy {
  langCode: any = "en";
  windowType: string;
  isCountryAllowed: number;
  isUserLoggedin: boolean = false;
  bannerHTML: string = '';
  userFullName: String = "";
  userDetails: any;
  bannersAvailable: boolean = false;
  bannerLis: string = '';
  isZimplerCountryAllowed: any;
  destroy$: Subject<boolean> = new Subject<boolean>();
  banners;
  siteUrlPath = environment.siteUrl;
  webisteCode = environment.website_code;
  cashBalance;
  bonusBalance;
  userCurrencySymbol;
  mediaUrlPath = environment.mediaPath;
  @Input() isHideCommonHeader = false;
  pnpLanguage= pnpLanguagePaymentlogos;

  constructor(
    private appDetails: AppDetailsService,
    private router: Router,
    private bannerService: BannerService,
    private emitter: EmitterService,
    private utils: Utility,
    private countryDataService: CountryDataService,
    private userService: UserDetailsService,
    private profileSettingService: ProfileSettingService
  ) {
    this.emitter.loadHomeBanner$.pipe(takeUntil(this.destroy$)).subscribe(message => {
      this.loadbanner();
    });

    this.emitter.isCountryAllowed$.pipe(takeUntil(this.destroy$)).subscribe(data=>{
      this.isZimplerCountryAllowed = data;
    })
  
    this.emitter.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(message => {
      if (localStorage.getItem("langCode") !== message) {
        this.loadbanner();
      }
    });

    this.userService.userProfileUpdated$.pipe(takeUntil(this.destroy$)).subscribe(update => {
      this.userFullName = new TitleCasePipe().transform(this.userService.getUserName());
    })

    this.userService.userCashBalanceUpdated$.pipe(takeUntil(this.destroy$)).subscribe(cashBalance => {
      this.loadbanner();
    });

    this.userService.userBonusBalanceUpdated$.pipe(takeUntil(this.destroy$)).subscribe(bonusBalance => {
      this.loadbanner();
    });

    this.emitter.updateLoginStatus$.pipe(takeUntil(this.destroy$)).subscribe(status => {
      this.isUserLoggedin = status;
      this.initializeBanners();
    });
  }

  ngOnInit() {
    this.deviceType();
    this.isUserLoggedin = this.utils.isUserLoggedIn();
    this.initializeBanners();
  }
  
  @HostListener('window:resize') onResize() {
    this.deviceType();
  }

  initializeBanners() {
    if (this.isUserLoggedin) {
      this.userFullName = this.userService.getUserName();
      if(this.userFullName === ""){
        Promise.resolve(this.profileSettingService.getProfileData(true)).then(
          (profileData) => {
            this.userDetails = profileData;
            this.userFullName = this.userDetails.firstName;
            this.loadbanner();
          }
        );
      } else{
        this.loadbanner();
      }
    } else{
      this.loadbanner();
    }
  }

  deviceType() {
    const ww = document.body.clientWidth;
    if (ww <= 992) {
      this.windowType = "mobile";
    } else {
      this.windowType = "desktop";
    }
  }

  loadbanner() {
    let bannerRequest = { 'zoneId': '1' };
    let self = this;
    if (this.utils.getAffliateId('affiliate')) {
      bannerRequest["affiliateId"] = this.utils.getAffliateId('affiliate');
    }
    this.isCountryAllowed = 0;
    Promise.resolve(this.bannerService.getBanners(bannerRequest)).then((bannersResp) => {
      this.getCountry();
      let bannersRespClone = JSON.parse(JSON.stringify(bannersResp));
      
      if (bannersRespClone && bannersRespClone.length > 0) {
        bannersRespClone.forEach((banner) => {
          banner.content = banner.content.replace(/{{site_url}}/g, environment.siteUrl);
          banner.content = banner.content.replace(/{{website_code}}/g, environment.website_code);

          if(this.isUserLoggedin) {
            this.userCurrencySymbol = this.userService.getUserCurrencySymbol();
            this.cashBalance = this.userService.getUserFormatedBalence(this.userService.getUserCashBalance())
            this.bonusBalance = this.userService.getUserFormatedBalence(this.userService.getUserBonusBalance())
            banner.content = banner.content.replace(/{{user_full_name}}/g, this.userFullName);
            banner.content = banner.content.replace(/{{main_balance}}/g, this.cashBalance);
            banner.content = banner.content.replace(/{{bonus_balance}}/g, this.bonusBalance);
          }

          this.banners = banner.content;

          // Modifying CTA Buttons to add attribute from banner TargetURL
          setTimeout(() => {
            let ctaButton = $('.slider').find('.cm-slider__btn--cta');
            if(ctaButton && ctaButton.length > 0) {
              if(!$('.cm-slider__btn--cta').data('target')) {
                $('.cm-slider__btn--cta').attr('data-target', banner.targetUrl);
              }
            }
          });
        });
       let self = this;
        setTimeout(() => {
          $('.cm-slider__btn--cta').on('click', function () {
            let targetAttribute = $(this).data("target");
            if(targetAttribute) {
            if(targetAttribute.includes('register')){
              self.emitter.broadCastXSaleRegistration(true)
            }else{
              let targetSplit = targetAttribute.split('?');
              if(targetAttribute.indexOf('?') > 0) {
                if(targetSplit[1]) {
                  self.router.navigate([self.langCode+'/' + targetSplit[0]], {queryParams: self.utils.parseQuery(targetSplit[1])});
                } else {
                  self.router.navigate([self.langCode+'/'+targetSplit[0]]);
                }
              } else {
                if(targetAttribute.indexOf('?') === -1) {
                  self.router.navigate([self.langCode + '/' + targetAttribute]);
                } else {
                  if(targetSplit[1]){
                    let params:any=self.utils.parseQuery(targetSplit[1]);
                    params.time=new Date().getTime();
                    self.router.navigate([self.langCode], { queryParams: params }).then(()=>{
                      history.replaceState(null,"", self.router.createUrlTree([self.langCode]).toString())
                    });
                  } else {
                    self.router.navigate([self.langCode]);
                  }
                }
              }
            }
            }
          });
        }, 1);
      } else {
        this.banners = bannersRespClone;
      }
    });
  }


  getCountry(country?: String) {
    if (environment.trustlyCountries.indexOf(this.countryDataService.ipCountry.toUpperCase()) >= 0) {
      this.isCountryAllowed = 1;
      this.appDetails.country = this.countryDataService.ipCountry;
    } else {
      this.isCountryAllowed = 2;
      this.appDetails.country = null;
    }
  }

  langCodeBasedPaymentLogosForNonPnp(){
    let langCode = localStorage.getItem('langCode') ? localStorage.getItem('langCode') : 'en'
    return this.pnpLanguage.indexOf(langCode) >=0
  }
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}



